import React from 'react';
import styled, { keyframes } from 'styled-components';

import { getColor } from '../styles/themeGetters';

const loadingDotsAnimation = keyframes`
  0% {
    transform: scale(0);
  }
  80%,
  100% {
   transform: scale(1);
  }
`;

const LoadingDotsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;

const LoadingDot = styled.div<{ animationDelay?: number }>`
  background-color: ${getColor('navy')};
  border-radius: 50%;
  width: 4px;
  height: 4px;
  animation: ${loadingDotsAnimation} 0.5s infinite ease-in-out alternate;
  animation-delay: ${({ animationDelay }) => `${animationDelay}s`};
`;

export const LoadingDots: React.FC = () => (
  <LoadingDotsContainer>
    <LoadingDot />
    <LoadingDot animationDelay={0.2} />
    <LoadingDot animationDelay={0.3} />
  </LoadingDotsContainer>
);
